import { Link } from "react-router-dom";
import { Lock, Crown } from "lucide-react";

// Shown in place of a gated page's content (Analytics, Sinking Funds, Investments) when
// the current user's plan doesn't include it. See lib/plans.js's hasProAccess().
export default function UpsellCard({ feature, description, requiredPlan = "Pro" }) {
    return (
        <div className="card-elev rounded-2xl p-10 text-center max-w-lg mx-auto mt-8" data-testid="upsell-card">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-500 grid place-items-center mx-auto mb-4 shadow-sm shadow-amber-500/20">
                <Lock className="w-6 h-6 text-white" />
            </div>
            <h2 className="font-display text-xl font-extrabold text-slate-900 mb-2">
                {feature} is a {requiredPlan} feature
            </h2>
            <p className="text-sm text-slate-500 mb-6">{description}</p>
            <Link
                to="/pricing"
                data-testid="upsell-view-plans"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white text-sm font-semibold shadow-sm shadow-amber-500/20 transition-all"
            >
                <Crown className="w-4 h-4" /> View plans
            </Link>
        </div>
    );
}
